module.exports = __webpack_public_path__ + "img/H1.04791115.png";